import { axios } from '@/utils/request'

const api = {
  brand: '/enterprise/brand'
}

export function getBrandList (parameter) {
  return axios({
    url: api.brand + '/queryBrand',
    method: 'get',
    params: parameter
  })
}

// export function addBrand (parameter) {
//   return axios({
//     url: api.brand + '/addBrand',
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export function saveBrand (parameter) {
  return axios({
    url: api.brand + (parameter.brandId == 0 ? '/addBrand' : '/editBrand'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delBrand (parameter) {
  return axios({
    url: api.brand + '/deleteBrand',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用品牌
export function banBrand (parameter) {
  return axios({
    url: api.brand + '/forbiddenBrand',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//启动品牌
export function enanBrand (parameter) {
  return axios({
    url: api.brand + '/enableBrand',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export const brandExport = api.brand + '/export'
